@let t = text();

@if (visible()) {
  <section class="hd-cycles-section">
    <h4 class="hd-cycles-section__title">
      <span>{{ t.title }}</span>
      @if (savedChartId() && isStandardView()) {
        <button type="button" class="hd-cycles-section__title-action"
                [attr.aria-label]="t.refresh" [title]="t.refresh" (click)="refresh()">
          <i class="fas fa-rotate-right" aria-hidden="true"></i>
        </button>
      }
    </h4>

    @if (isCycleView() || isMomentView()) {
      @if (cycleInfo(); as info) {
        <!-- Algemene cyclus info: amber subsectie-titel boven de cyclus-header. -->
        <h4 class="hd-cycles-section__subsection-title">{{ generalInfoTitle() }}</h4>

        <!-- Prominente cyclus-header (kader met primary-dusk-border); met
             cheat-sheet-info is de hele regel klikbaar om uit te klappen. -->
        <ng-template #cycleHeaderContent>
          <i [class]="'fas fa-' + info.icon + ' hd-cycles-section__icon'" aria-hidden="true"></i>
          <span class="hd-cycles-section__label hd-cycles-section__label--cycle">
            {{ info.label }}
            @if (info.glyph) {
              <span class="hd-cycles-section__glyph" aria-hidden="true">{{ info.glyph }}</span>
            }
          </span>
          <span class="hd-cycles-section__moment">
            {{ info.momentText }}
            @if (info.ageYears != null) {
              <hd-age-suffix [years]="info.ageYears" [tooltip]="info.ageTooltip" />
            }
          </span>
          @if (cycleCardInfo()) {
            <i class="fas fa-chevron-right hd-cycles-section__info-chevron"
               [class.hd-cycles-section__info-chevron--open]="cycleCardInfoExpanded()"
               aria-hidden="true"></i>
          }
        </ng-template>

        @if (cycleCardInfo(); as cardInfo) {
          <button type="button" class="hd-cycles-section__cycle-header hd-cycles-section__cycle-header--clickable"
                  [attr.title]="info.tooltip"
                  [attr.aria-expanded]="cycleCardInfoExpanded()"
                  [attr.aria-label]="cycleCardInfoExpanded() ? cardInfo.hideLabel : cardInfo.showLabel"
                  (click)="toggleCycleCardInfo()">
            <ng-container [ngTemplateOutlet]="cycleHeaderContent"></ng-container>
          </button>
        } @else {
          <div class="hd-cycles-section__cycle-header" [attr.title]="info.tooltip">
            <ng-container [ngTemplateOutlet]="cycleHeaderContent"></ng-container>
          </div>
        }
        @if (cycleCardInfoExpanded() && cycleCardInfo(); as cardInfo) {
          <div class="hd-cycles-section__card-info">
            @if (cardInfo.subtitle) {
              <div class="hd-cycles-section__card-info-subtitle">{{ cardInfo.subtitle }}</div>
            }
            @if (cardInfo.timing) {
              <div class="hd-cycles-section__card-info-timing">
                <i class="fas fa-clock hd-cycles-section__card-info-timing-icon" aria-hidden="true"></i>
                <span>{{ cardInfo.timing }}</span>
              </div>
            }
            <ul class="hd-cycles-section__card-info-bullets">
              @for (bullet of cardInfo.bullets; track $index) {
                <li [innerHTML]="bullet"></li>
              }
            </ul>
            <!-- Chiron return: drieluik wond → werk → resolutie met de poort.lijn van deze persoon. -->
            @if (chironPositions(); as chiron) {
              <!-- Kern van de Chiron return: geen gewone kaart, wel een kaart van je ware zelf. -->
              @if (chiron.essence.quote) {
                <div class="hd-cycles-section__chiron-essence" data-test-id="cycle-chiron-essence">
                  <div class="hd-cycles-section__chiron-title">
                    <span class="hd-cycles-section__chiron-title-glyph" aria-hidden="true">{{ chironGlyph }}</span>
                    <span>{{ chiron.essence.title }}</span>
                  </div>
                  <blockquote class="hd-cycles-section__chiron-quote">
                    <span>{{ chiron.essence.quote }}</span>
                    @if (chiron.essence.quoteSource) {
                      <cite class="hd-cycles-section__chiron-quote-source">{{ chiron.essence.quoteSource }}</cite>
                    }
                  </blockquote>
                  <div class="hd-cycles-section__chiron-essence-row" data-kind="is">
                    <i class="fas fa-key" aria-hidden="true"></i>
                    <span [innerHTML]="chiron.essence.is"></span>
                  </div>
                  <div class="hd-cycles-section__chiron-essence-row" data-kind="is-not">
                    <i class="fas fa-glasses" aria-hidden="true"></i>
                    <span [innerHTML]="chiron.essence.isNot"></span>
                  </div>
                </div>
              }
              <div class="hd-cycles-section__chiron" data-test-id="cycle-chiron-positions">
                <div class="hd-cycles-section__chiron-title">
                  <span class="hd-cycles-section__chiron-title-glyph" aria-hidden="true">{{ chironGlyph }}</span>
                  <span>{{ chiron.title }}</span>
                </div>
                @if (chiron.intro) {
                  <p class="hd-cycles-section__chiron-intro">{{ chiron.intro }}</p>
                }
                <ol class="hd-cycles-section__chiron-steps">
                  @for (step of chiron.steps; track step.role) {
                    <li class="hd-cycles-section__chiron-step" [attr.data-role]="step.role"
                        [attr.data-test-id]="'cycle-chiron-step-' + step.role">
                      <span class="hd-cycles-section__chiron-node" aria-hidden="true">
                        <i [class]="'fas fa-' + step.icon"></i>
                      </span>
                      <div class="hd-cycles-section__chiron-body">
                        <div class="hd-cycles-section__chiron-head">
                          <span class="hd-cycles-section__chiron-step-title">{{ step.title }}</span>
                          @if (step.position; as position) {
                            <button type="button" class="hd-cycles-section__chiron-chip"
                                    [attr.data-side]="step.side"
                                    [title]="step.gateTooltip" [attr.aria-label]="step.gateTooltip"
                                    (click)="requestChironInfo(step, $event)">
                              <span class="hd-cycles-section__chiron-chip-glyph" aria-hidden="true">{{ chironGlyph }}</span>{{ position.gate }}.{{ position.line }}
                            </button>
                          }
                        </div>
                        <div class="hd-cycles-section__chiron-source">{{ step.source }}</div>
                        <div class="hd-cycles-section__chiron-text" [innerHTML]="step.text"></div>
                        @if (step.role === 'resolution' && chiron.sameSpot) {
                          <div class="hd-cycles-section__chiron-same-spot">
                            <i class="fas fa-equals" aria-hidden="true"></i> {{ chiron.sameSpot }}
                          </div>
                        }
                      </div>
                    </li>
                  }
                </ol>
                @if (chiron.notes.length > 0) {
                  <ul class="hd-cycles-section__chiron-notes">
                    @for (note of chiron.notes; track $index) {
                      <li>{{ note }}</li>
                    }
                  </ul>
                }
                @if (chiron.sourceNote) {
                  <div class="hd-cycles-section__chiron-source-note">{{ chiron.sourceNote }}</div>
                }
              </div>
            }
            <!-- App-only verdieping (niet op de cheat sheet): extra bullets, 6de-lijn-regels,
                 zuid→noord-kanteling van de natal nodes en de kruishoek van het cyclusmoment. -->
            @if (cardInfo.hasExtra) {
              <div class="hd-cycles-section__card-info-extra">
                @if (cardInfo.extraBullets.length > 0) {
                  <ul class="hd-cycles-section__card-info-bullets">
                    @for (bullet of cardInfo.extraBullets; track $index) {
                      <li [innerHTML]="bullet"></li>
                    }
                  </ul>
                }
                @if (cardInfo.gotcha; as gotcha) {
                  <div class="hd-cycles-section__card-info-extra-title hd-cycles-section__card-info-extra-title--gotcha"
                       data-test-id="cycle-gotcha">
                    <i class="fas fa-triangle-exclamation" aria-hidden="true"></i>
                    <span>{{ gotcha.title }}</span>
                  </div>
                  <ul class="hd-cycles-section__card-info-bullets">
                    @for (bullet of gotcha.bullets; track $index) {
                      <li [innerHTML]="bullet"></li>
                    }
                  </ul>
                }
                @if (cardInfo.sixthLine; as sixthLine) {
                  <div class="hd-cycles-section__card-info-extra-title">{{ sixthLine.title }}</div>
                  <ul class="hd-cycles-section__card-info-bullets hd-cycles-section__card-info-bullets--sixth-line">
                    @for (bullet of sixthLine.bullets; track $index) {
                      <li [innerHTML]="bullet"></li>
                    }
                  </ul>
                }
                @if (cardInfo.nodeShift; as nodeShift) {
                  <div class="hd-cycles-section__card-info-data hd-cycles-section__card-info-data--node-shift"
                       [attr.title]="nodeShift.tooltip">
                    <span class="hd-cycles-section__card-info-data-label">{{ nodeShift.label }}</span>
                    <span class="hd-cycles-section__card-info-data-value">{{ nodeShift.value }}</span>
                    <button type="button" class="hd-cycles-section__info-button"
                            [attr.aria-label]="nodeShift.tooltip"
                            (click)="requestNatalLifeCrossInfo(nodeShift.lifeCross)">
                      <i class="fas fa-circle-info" aria-hidden="true"></i>
                    </button>
                  </div>
                }
                @if (cardInfo.crossAngle; as crossAngle) {
                  <div class="hd-cycles-section__card-info-data hd-cycles-section__card-info-data--cross-angle"
                       [attr.title]="crossAngle.tooltip">
                    <span class="hd-cycles-section__card-info-data-label">{{ crossAngle.label }}</span>
                    <span class="hd-cycles-section__card-info-data-value" [innerHTML]="crossAngle.text"></span>
                  </div>
                }
              </div>
            }
          </div>
        }

        <!-- Profiel + incarnatiekruis + levenskruis van het cycle-moment, onder de cyclus-subsectie;
             het match-icoon klapt de lijst met gelijkaardige bibliotheek-charts uit. -->
        @if (cycleMomentProperties(); as props) {
          @if (props.profileText) {
            <div class="hd-cycles-section__row">
              <span class="hd-cycles-section__label">{{ props.profileLabel }}</span>
              <span class="hd-cycles-section__value">{{ props.profileText }}</span>
              <button type="button" hdChartMatchToggle class="hd-cycles-section__match-toggle"
                      [open]="isMatchesExpanded('profile')"
                      [tooltip]="t.matchesProfileTooltip"
                      (click)="toggleMatches('profile')"></button>
            </div>
            @if (isMatchesExpanded('profile')) {
              <ng-container [ngTemplateOutlet]="matchList"
                            [ngTemplateOutletContext]="{ $implicit: matchState('profile') }"></ng-container>
            }
          }
          @if (props.crossText) {
            <div class="hd-cycles-section__row">
              <span class="hd-cycles-section__label">{{ props.crossLabel }}</span>
              <span class="hd-cycles-section__value">{{ props.crossText }}</span>
              <button type="button" hdChartMatchToggle class="hd-cycles-section__match-toggle"
                      [open]="isMatchesExpanded('incarnationCross')"
                      [tooltip]="t.matchesCrossTooltip"
                      (click)="toggleMatches('incarnationCross')"></button>
            </div>
            @if (isMatchesExpanded('incarnationCross')) {
              <ng-container [ngTemplateOutlet]="matchList"
                            [ngTemplateOutletContext]="{ $implicit: matchState('incarnationCross') }"></ng-container>
            }
          }
          <!-- Levenskruis van het cycle-moment (label "Nodale omgeving"): het
               info-icoon opent de nodale omgevingen (+ lijnen) van deze cyclus. -->
          @if (props.lifeCross; as lifeCross) {
            <div class="hd-cycles-section__row hd-cycles-section__row--life-cross">
              <span class="hd-cycles-section__label">{{ props.lifeCrossLabel }}</span>
              <span class="hd-cycles-section__value">{{ props.lifeCrossText }}</span>
              <button type="button" class="hd-cycles-section__info-button"
                      [attr.aria-label]="props.lifeCrossInfoTooltip"
                      [title]="props.lifeCrossInfoTooltip"
                      (click)="requestLifeCrossInfo(lifeCross)">
                <i class="fas fa-circle-info" aria-hidden="true"></i>
              </button>
            </div>
          }
        }

        <!-- Definitie van de volledige cycle chart (natal + cyclus) onder de nodale
             omgeving, met brugpoorten bij een split en een cyclus-specifieke hint. -->
        @if (cycleDefinition(); as definition) {
          <div class="hd-cycles-section__row hd-cycles-section__row--definition">
            <span class="hd-cycles-section__label">{{ definition.label }}</span>
            <span class="hd-cycles-section__value">
              {{ definition.text }}
              @if (definition.natalText) {
                <span class="hd-cycles-section__natal-definition">({{ definition.natalText }})</span>
              }
            </span>
            <button type="button" class="hd-cycles-section__info-button"
                    [attr.aria-label]="definition.infoTooltip"
                    [title]="definition.infoTooltip"
                    (click)="requestDefinitionInfo(definition.definitionKey, $event)">
              <i class="fas fa-circle-info" aria-hidden="true"></i>
            </button>
          </div>
          @if (definition.hint || definition.bridgeGates.length > 0) {
            <div class="hd-cycles-section__card-info hd-cycles-section__definition-hint">
              @if (definition.bridgeGates.length > 0) {
                <div class="hd-cycles-section__bridge-gates">
                  <span class="hd-cycles-section__bridge-label">{{ definition.bridgeLabel }}</span>
                  @for (bridge of definition.bridgeGates; track $index) {
                    <span class="hd-cycles-section__bridge-item">
                      @for (gate of bridge; track $index) {
                        <button type="button" class="hd-cycles-section__bridge-gate"
                                (click)="requestGateInfo(gate, $event)">{{ gate }}</button>
                        @if (!$last) {<span>-</span>}
                      }
                    </span>
                  }
                </div>
              }
              @if (definition.hint) {
                <div>{{ definition.hint }}</div>
              }
            </div>
          }
        }

        <!-- Gedeelde matchlijst-weergave (laden / fout / leeg / items). -->
        <ng-template #matchList let-state>
          <div class="hd-cycles-section__match-list">
            <hd-chart-match-list [state]="state"
                                 [labels]="{ loading: t.loading, empty: t.matchesEmpty, error: t.matchesError }"
                                 (open)="openMatch($event)">
              <ng-template let-entry>
                @if (entry.item.hdProfile) {
                  <span class="hd-cycles-section__match-item-meta">{{ entry.item.hdProfile }}</span>
                }
              </ng-template>
            </hd-chart-match-list>
          </div>
        </ng-template>
        @if (staleState() === 'stale') {
          <div class="hd-cycles-section__row hd-cycles-section__row--stale" [attr.title]="t.outdatedTooltip">
            <span class="hd-cycles-section__stale-badge">{{ t.outdated }}</span>
            <button type="button" class="hd-cycles-section__action" (click)="recalculateRequested.emit()">
              {{ t.recalculate }}
            </button>
          </div>
        } @else if (staleState() === 'missing') {
          <div class="hd-cycles-section__empty">{{ t.natalUnavailable }}</div>
        }
      }
    } @else if (viewMode() !== 'owner') {
      <!-- Gedeelde chart (spec 2026-10-20-chart-share §4.5): geen library-lijst. -->
      <div class="hd-cycles-section__empty">{{ t.sharedUnavailable }}</div>
    } @else if (!savedChartId()) {
      <div class="hd-cycles-section__empty">{{ t.saveFirst }}</div>
    } @else if (momentsLoading()) {
      <div class="hd-cycles-section__empty">{{ t.loading }}</div>
    } @else if (momentsError()) {
      <div class="hd-cycles-section__error">{{ momentsError() }}</div>
    } @else {
      @for (row of rows(); track row.key) {
        <div class="hd-cycles-section__row" [attr.title]="row.tooltip">
          <i [class]="'fas fa-' + row.icon + ' hd-cycles-section__icon'" aria-hidden="true"></i>
          <span class="hd-cycles-section__label">
            {{ row.label }}
            @if (row.glyph) {
              <span class="hd-cycles-section__glyph" aria-hidden="true">{{ row.glyph }}</span>
            }
          </span>
          @if (row.key === 'solarReturn') {
            <ng-select class="hd-cycles-section__year"
                       appendTo="body"
                       [items]="yearOptions()"
                       [clearable]="false"
                       [placeholder]="t.yearPlaceholder"
                       [ngModel]="selectedYear()"
                       (ngModelChange)="onYearChange($event)"></ng-select>
          } @else if (row.key === 'jupiterReturn') {
            <ng-select class="hd-cycles-section__year hd-cycles-section__return-picker"
                       [items]="jupiterOptions()"
                       bindValue="value"
                       bindLabel="label"
                       [clearable]="false"
                       [searchable]="false"
                       [placeholder]="t.jupiterReturnPlaceholder"
                       [ngModel]="selectedJupiterNumber()"
                       (ngModelChange)="onJupiterNumberChange($event)"></ng-select>
          }
          <span class="hd-cycles-section__moment">
            {{ row.momentText ?? t.now }}
            @if (row.passagesBadge) {
              <span class="hd-cycles-section__passages">{{ row.passagesBadge }}</span>
            }
          </span>
          <button type="button" class="hd-cycles-section__action" (click)="requestCalculate(row)">
            {{ row.savedChartId ? t.open : t.calculate }}
          </button>
        </div>
      }
    }
  </section>
}
